module.exports = __webpack_public_path__ + "static/media/13ITC1.e9d400d8.jpg";